import { render, staticRenderFns } from "./Welfare.vue?vue&type=template&id=6d9ad98c&scoped=true"
import script from "./Welfare.vue?vue&type=script&lang=js"
export * from "./Welfare.vue?vue&type=script&lang=js"
import style0 from "./Welfare.vue?vue&type=style&index=0&id=6d9ad98c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9ad98c",
  null
  
)

export default component.exports